import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  IContainerImportDischarge,
  IContainerImportDischargeInitialState,
} from "./containerImportDischargeModel";
import {
  getAllContainerImportDischarge,
  createContainerImportDischarge,
  deleteContainerImportDischarge,
  getContainerImportDischargeByID,
  updateContainerImportDischarge,
} from "./services/containerImportDischarge.services";

const initialState: IContainerImportDischargeInitialState = {
  loading: false,
  error: "",
  FilterCustomCID: {
    vessels_name: "",
  },
  ContainerImportDischargeID: null,
  ContainerImportDischargeGUID: "",
  ContainerImportDischargeList: [],
  ContainerImportDischargeDetail: {
    eta: "",
    vessels_name: "",
    vcn: "",
    agent_id: "",
    cargo: "",
    // form_type:"",
  },
};

const containerImportDischargeSlice = createSlice({
  name: "containerImportDischarge",
  initialState,
  reducers: {
    clearContainerImportDischargeDetails: (state) => {
      state.ContainerImportDischargeDetail =
        initialState.ContainerImportDischargeDetail;
    },
    setContainerImportDischargeID: (state, action) => {
      state.ContainerImportDischargeID = action.payload;
    },
    clearContainerImportDischargeID: (state) => {
      state.ContainerImportDischargeID =
        initialState.ContainerImportDischargeID;
    },
    setContainerImportDischargeGUID: (state, action) => {
      state.ContainerImportDischargeGUID = action.payload;
    },
    clearContainerImportDischargeGUID: (state) => {
      state.ContainerImportDischargeGUID =
        initialState.ContainerImportDischargeGUID;
    },
    setFilterCustomCID: (state, action) => {
      state.FilterCustomCID = action.payload;
    },
    clearFilterCustomCID: (state) => {
      state.FilterCustomCID = initialState.FilterCustomCID;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllContainerImportDischarge.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllContainerImportDischarge.fulfilled,
      (state, action: PayloadAction<IContainerImportDischarge[]>) => {
        state.loading = false;
        state.ContainerImportDischargeList = action.payload || [];
      }
    );
    builder.addCase(
      getAllContainerImportDischarge.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Something went wrong";
        state.ContainerImportDischargeList = [];
      }
    );

    builder.addCase(createContainerImportDischarge.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(createContainerImportDischarge.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(
      createContainerImportDischarge.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Something went wrong";
      }
    );
    builder.addCase(updateContainerImportDischarge.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(updateContainerImportDischarge.fulfilled, (state) => {
      state.loading = true;
    });
    builder.addCase(
      updateContainerImportDischarge.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Something went wrong";
      }
    );
    builder.addCase(deleteContainerImportDischarge.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteContainerImportDischarge.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(
      deleteContainerImportDischarge.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Something went wrong";
      }
    );
    builder.addCase(getContainerImportDischargeByID.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getContainerImportDischargeByID.fulfilled,
      (state, action: any) => {
        state.loading = false;
        state.ContainerImportDischargeDetail = action.payload;
      }
    );
    builder.addCase(
      getContainerImportDischargeByID.rejected,
      (state, action) => {
        state.loading = false;
        state.ContainerImportDischargeDetail =
          initialState.ContainerImportDischargeDetail;
        state.error = action.error.message || "Something went wrong";
      }
    );
  },
});

export const {
  clearContainerImportDischargeDetails,
  clearContainerImportDischargeID,
  setContainerImportDischargeID,
  clearContainerImportDischargeGUID,
  setContainerImportDischargeGUID,
  setFilterCustomCID,
  clearFilterCustomCID,
} = containerImportDischargeSlice.actions;
export default containerImportDischargeSlice.reducer;
